import Phaser from 'phaser'
import 'phaser/plugins/spine/dist/SpinePlugin'
import $ from "jquery";

import MainScene from './MainScene'
import LoadingScene from './Loading'

import { Plugin as NineSlicePlugin } from "phaser3-nineslice";
import DialogModalPlugin from "./DialogPlugin/phaser-dialog-modal-plugin";
const width = window.innerWidth;
const height = window.innerHeight;

const bgWidth = width/2;
const bgHeight = height/2;
const config = {
  type: Phaser.AUTO,
  width: bgWidth,
  height: bgHeight,
  parent: 'main-screen',
  dom: {
  createContainer: true
  },
  physics: {
      default: 'matter',
      arcade: {
          debug: false,
          gravity: { y: 0 }
      },
      matter: {
          debug: false,
          gravity: { y: 0 }
      }
  },

  scale: {
    mode: Phaser.Scale.Fit,
    parent: 'main-screen',
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: width/1.0,
    height: height/1.0
  },
  plugins: {
    global: [NineSlicePlugin.DefaultCfg],
    scene: [
      { key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' },
      {
        key: "DialogModalPlugin",
        plugin: DialogModalPlugin,
        mapping: "dialogPlugin",
        start: true
      }
    ]
},
  
fps: {
  target: 15,
  },
  
  scene: [LoadingScene,MainScene],
}
let canvasHtml = "<div id='main-screen'></div>"
$('body').append(canvasHtml);
export default new Phaser.Game(config)